<template>
  <div class="ml-3 info-button" @click="toggle">
    <label>i</label>
  </div>
  <OverlayPanel ref="infoOp" class="md:w-4 sm:w6">
    <div class="flex flex-column">
      <p class="text-800 font-normal">{{ message }}</p>
    </div>
  </OverlayPanel>
</template>
<script lang="ts" setup>
  import { ref } from 'vue'
  const infoOp = ref()

  const props = defineProps<{
    message: string
  }>()

  const toggle = (event: any) => {
    infoOp.value.toggle(event)
  }
</script>
<style scoped>
  .info-button {
    justify-content: center;
    align-self: center;
    height: 20px;
    width: 20px;
    min-width: 20px;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    background-color: #245cdd;
    color: #f7f7f7;
    box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 99%;
  }

  .info-button:hover {
    background-color: #245cdd;
    color: #f7f7f7;
    cursor: pointer;
  }
</style>
